export enum ContractEventType {
  CONTRACT_CREATED = 'ContractCreated',
  DATA_CHANGED = 'DataChanged',
  EXECUTED = 'Executed',
  UNIVERSAL_RECEIVER = 'UniversalReceiver',
  INITIALIZED = 'Initialized',
  OWNERSHIP_TRANSFER_STARTED = 'OwnershipTransferStarted',
  OWNERSHIP_TRANSFERRED = 'OwnershipTransferred',
  RENOUNCE_OWNERSHIP_STARTED = 'RenounceOwnershipStarted',
  OWNERSHIP_RENOUNCED = 'OwnershipRenounced',
}

export const ContractEventTypeArray: ContractEventType[] =
  Object.values(ContractEventType)

export type EventData = {
  event: string
  address: string
  removed?: boolean
  signature?: string | null
  returnValues: {
    [key: string]: any
  }
  logIndex: number
  transactionIndex: number
  transactionHash: string
  blockHash: string
  blockNumber: number
  raw: {
    data: string
    topics: string[]
  }
}
